import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/settledBets.css';
// helpers
import {getText} from '../../../helpers/localization';
import {getModuleFromEventType} from '../../../helpers/moduleHelpers';
import {getBetHistory} from "../helpers/betHistoryHelpers";
// constants
import {
    AMERICAN_FOOTBALL_MODULE, BASEBALL_MODULE,
    BASKETBALL_MODULE, CRICKET_MODULE,
    FIRST_DOWN_MODULE,
    FOOTBALL_MODULE,
    MATCHDAY_MODULE,
    RACING_MODULE,
    SETTLED, TENNIS_MODULE,
    VOIDED
} from '../../../constants/identifiers';
// components
import LockedBetFootball from '../modules/football/components/lockedBetFootball';
import LockedBetRacing from '../modules/racing/components/lockedBetRacing';
import LockedBetFirstDown from '../modules/firstDown/components/lockedBetFirstDown';
import Accordion from '../components/accordion';
import {toggleFilterWinsSettledBets} from "../actions/betSlipActions";
import LockedBetBasketball from "../modules/basketball/components/lockedBetBasketball";
import LockedBetAmericanFootball from "../modules/americanFootball/components/lockedBetAmericanFootball";
import {collapseSettledBetAccordion} from './../../../actions/betSlipActions';
import LockedBetMatchday from "../modules/matchday/components/lockedBetMatchday";
import {getGameCategoryNameByChannel} from '../helpers/gameHelpers';
import LockedBetCricket from "../modules/cricket/components/lockedBetCricket";
import LockedBetTennis from '../modules/tennis/components/lockedBetTennis';
import LockedBetBaseball from '../modules/baseball/components/lockedBetBaseball';
import { isBetSettled } from '../helpers/betHelpers';

const mapStateToProps = (state, ownProps) => {
    return {
        settledBets: state.vpp.settledBets,
        filterWinsSettledBets: state.vpp.filterWinsSettledBets,
        isPlatformReady: state.vpp.isPlatformReady,
        collapsedSettledBetAccordions: state.vpp.collapsedSettledBetAccordions,
        systemLanguage: state.vpp.systemLanguage,
        games: state.vpp.games,
        serverTimeOffset: state.vpp.serverTimeOffset,
        events: state.vpp.events,
    };
};

class SettledBets extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            settledBets: storeData.vpp.settledBets,
            filterWinsSettledBets: storeData.vpp.filterWinsSettledBets,
            isPlatformReady: storeData.vpp.isPlatformReady,
            collapsedSettledBetAccordions: storeData.vpp.collapsedSettledBetAccordions,
            systemLanguage: storeData.vpp.systemLanguage,
            games: storeData.vpp.games,
            serverTimeOffset: storeData.vpp.serverTimeOffset,
            events: storeData.vpp.events,
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                settledBets: storeData.vpp.settledBets,
                filterWinsSettledBets: storeData.vpp.filterWinsSettledBets,
                isPlatformReady: storeData.vpp.isPlatformReady,
                collapsedSettledBetAccordions: storeData.vpp.collapsedSettledBetAccordions,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    _handleAccordionClick(gameCategory) {
        this.props.store.dispatch(collapseSettledBetAccordion(gameCategory))
    }

    render() {
        let gameCategoriesSettledBets;
        let isEmpty = true;
        let gameCategories;

        if (this.props.store.getState().vpp.games !== undefined && this.state.settledBets.length > 0) {
            let settledBetsList = this.state.settledBets;
            if (this.state.filterWinsSettledBets === true) {
                settledBetsList = settledBetsList.filter(sb => Number(sb.Bets[0].Prize) > 0 && sb.Bets[0].State !== VOIDED);
            }
            settledBetsList.sort((a, b) => b.Bets[0].EventTime - a.Bets[0].EventTime);
            gameCategories = [...new Set(settledBetsList.map(betSelection => getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel)))];
            gameCategoriesSettledBets = gameCategories.map((gameCategory, gameIndex) => {
                let eventsOfGivenGame = settledBetsList.filter((betSelection) => gameCategory === getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel)
                        && isBetSettled(this.props.store, betSelection, this.state.serverTimeOffset));

                if (eventsOfGivenGame !== undefined && eventsOfGivenGame.length !== 0 && getModuleFromEventType(eventsOfGivenGame[0].Bets[0].EventType) === MATCHDAY_MODULE) {
                    eventsOfGivenGame.sort(function (a, b) {
                        if (a.Bets.length > b.Bets.length) return 1;
                        if (a.Bets.length < b.Bets.length) return -1;
                        if (a.Bets[0].LastUpdatedDate > b.Bets[0].LastUpdatedDate) return -1;
                        if (a.Bets[0].LastUpdatedDate < b.Bets[0].LastUpdatedDate) return 1;
                    });
                }
                return eventsOfGivenGame.map((betSelection, betSelectionIndex) => {
                    isEmpty = false;
                    let settledBetCard = null;
                    let module = getModuleFromEventType(betSelection.Bets[0].EventType);

                    if (betSelection.Bets[0].EventType !== undefined && (this.state.filterWinsSettledBets === false || Number(betSelection.Bets[0].Prize) > 0)) {
                        switch (module) {
                            case RACING_MODULE:
                                settledBetCard = (
                                    <LockedBetRacing key={gameIndex + betSelectionIndex}
                                                     index={gameIndex + '_' + betSelectionIndex}
                                                     store={this.props.store} betSelection={betSelection}
                                                     isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            case FOOTBALL_MODULE:
                                settledBetCard = (
                                    <LockedBetFootball key={gameIndex + betSelectionIndex}
                                                       index={gameIndex + betSelectionIndex}
                                                       store={this.props.store} betSelection={betSelection}
                                                       isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            case BASKETBALL_MODULE:
                                settledBetCard = (
                                    <LockedBetBasketball key={gameIndex + betSelectionIndex}
                                                         index={gameIndex + betSelectionIndex}
                                                         store={this.props.store} betSelection={betSelection}
                                                         isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            case AMERICAN_FOOTBALL_MODULE:
                                settledBetCard = (
                                    <LockedBetAmericanFootball key={gameIndex + betSelectionIndex}
                                                               index={gameIndex + betSelectionIndex}
                                                               store={this.props.store} betSelection={betSelection}
                                                               isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            case FIRST_DOWN_MODULE:
                                settledBetCard = (
                                    <LockedBetFirstDown key={gameIndex + betSelectionIndex}
                                                        index={gameIndex + betSelectionIndex}
                                                        store={this.props.store} betSelection={betSelection}
                                                        isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            case MATCHDAY_MODULE:
                                settledBetCard = (<LockedBetMatchday key={gameIndex + betSelectionIndex}
                                                                     index={gameIndex + betSelectionIndex}
                                                                     store={this.props.store} isSettledBet={true}
                                                                     betSelection={betSelection} betsType={SETTLED}/>);
                                break;
                            case CRICKET_MODULE:
                                settledBetCard = (
                                    <LockedBetCricket key={gameIndex + betSelectionIndex}
                                                         index={gameIndex + betSelectionIndex}
                                                         store={this.props.store} betSelection={betSelection}
                                                         isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            case TENNIS_MODULE:
                                settledBetCard = (
                                    <LockedBetTennis key={gameIndex + betSelectionIndex}
                                                    index={gameIndex + betSelectionIndex}
                                                    store={this.props.store} betSelection={betSelection}
                                                    isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            case BASEBALL_MODULE:
                                settledBetCard = (
                                    <LockedBetBaseball key={gameIndex + betSelectionIndex} game={"baseball"}
                                                    index={gameIndex + betSelectionIndex}
                                                    store={this.props.store} betSelection={betSelection}
                                                    isSettledBet={true} betsType={SETTLED}/>);
                                break;
                            default:
                                settledBetCard = (<div key={gameIndex + betSelectionIndex}/>);
                                break;
                        }
                    }

                    return settledBetCard;
                });
            });
        }

        let gameCategoriesSettledBetsUI;
        if (isEmpty) {
            gameCategoriesSettledBetsUI = (
                <div className={style.noBetsText}>{getText('NO_BETS', this.props.store)}</div>);
        } else {
            gameCategoriesSettledBetsUI = gameCategoriesSettledBets.map((gameCategorySettledBets, index) => {
                if (gameCategorySettledBets.length > 0) {
                    let content = <div>{gameCategorySettledBets}</div>;
                    let isExpanded = !this.state.collapsedSettledBetAccordions.find((gameCategory) => gameCategory === gameCategories[index])
                    return <Accordion key={index} id={'game_accordion_' + index}
                                      store={this.props.store}
                                      content={content}
                                      onClick={this._handleAccordionClick.bind(this)}
                                      isExpanded={isExpanded}
                                      label={getText('betSlip_' + gameCategories[index], this.props.store)}
                                      collapseKey={gameCategories[index]}/>;
                }
                return null;
            });
        }

        let filterWinsButton = null;
        if (!isEmpty || true) {

            let isCheckStyle = this.state.filterWinsSettledBets ? style.selected : '';

            filterWinsButton = (
                <div
                    id={'filter_wins'}
                    className={`${style.filterWins} ${this.state.filterWinsSettledBets ? style.selected : ''}`}
                    onClick={() => this.props.store.dispatch(toggleFilterWinsSettledBets())}>
                    <div className={style.filterWinsLabel}>{getText('FILTER_WINS', this.props.store)}</div>
                    <div className={`${style.checkBox} ${isCheckStyle}`}/>
                </div>
            );
        }
        let betHistoryButton = null;
        if (this.state.isPlatformReady) {
            betHistoryButton = (
                <div id={'history_button'} className={style.historyButton}
                     onClick={() => getBetHistory(this.props.store.dispatch)}>{getText('BET_HISTORY', this.props.store)}
                </div>
            );
        } else {
            betHistoryButton = (
                <div id={'history_button'}
                     className={`${style.historyButton} ${style.disabled}`}>{getText('BET_HISTORY', this.props.store)}
                </div>
            );
        }
        let TAX_NOTIFICATION_TEXT = getText('TAX_NOTIFICATION_TEXT', this.props.store);
        let taxNotification = TAX_NOTIFICATION_TEXT != 'none' ? (
            <div className={style.taxNotification}>{TAX_NOTIFICATION_TEXT}</div>
        ) : '';

        return (<div className={style.mainContainer}>
            <div className={`${style.settledBetsAccordions} ${TAX_NOTIFICATION_TEXT != 'none'
                ? style.settledBetsAccordionsWithTaxText
                : ''}`}>
                {gameCategoriesSettledBetsUI}
            </div>
            {taxNotification}
            <div className={style.bottomContainer}>
                <div className={style.buttonsContainer}>
                    {filterWinsButton}
                    {betHistoryButton}
                </div>
            </div>
        </div>);
    }

}

export default connect(mapStateToProps)(SettledBets);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/settledBets.js